import { useEffect, useRef } from "react";

// Runs `callback` exactly once, deferring until `ready` is truthy. Re-runs on
// every dependency change until it actually fires, then never again -- use
// this instead of a `useRef` fired-guard + `if (!ready) return;` inlined in
// each call site (that pattern is easy to copy without the readiness check,
// silently reintroducing a race against async data that hasn't loaded yet).
export function useFireOnceWhenReady(
  ready: unknown,
  callback: () => void,
  deps: React.DependencyList
): void {
  const firedRef = useRef(false);
  useEffect(() => {
    if (firedRef.current || !ready) return;
    firedRef.current = true;
    callback();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
